import React, { useEffect, useState } from "react";
import AddUserManagementFormLayout from "../../layouts/AddUserManagementFormLayout/AddUserManagementFormLayout";
import CustomInput from "../../components/CustomInput/CustomInput";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { Text } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { addUserFormFieldNames } from "../../validationSchema/addUserManagementSchema";
import ProductCategoryService from "../../services/product-category-service";
import CustomMobileInput from "../../components/CustomMobileInput/CustomMobileInput";

export const BasicDetailsContainerStyles = {
  basicDetailsText: {
    fontWeight: variables.fontWeightBold,
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
  },
  mobileLabelStyle: {
    color: variables.textDefault,
    marginBottom: variables.marginSmall,
    lineHeight: variables.lineHeightSmall,
    fontSize: variables.fontSizeSmall,
  },
  requiredStyle: {
    color: variables.primaryBg,
  },
};

const BasicDetailsContainer = ({
  handleChange,
  values,
  errors,
  setFieldValue,
  touched,
  setCountryCodeValue,
  countryCodeValue,
  handleBlur,
}) => {
  const intl = useIntl();
  const [countriesData, setCountriesData] = useState([]);

  useEffect(() => {
    ProductCategoryService.getCountries(intl).then((data) => {
      setCountriesData(data?.result);
    });
  }, [intl]);

  const mobileChangeHandler = (e) => {
    setFieldValue([addUserFormFieldNames.MOB_NUM], e.target.value);
  };

  const countryCodeHandleChange = (e) => {
    setFieldValue([addUserFormFieldNames.COUNTRY_CODE], e);
  };

  return (
    <AddUserManagementFormLayout
      headerTopSection={
        <Text style={BasicDetailsContainerStyles.basicDetailsText}>
          {getLocalizedMessage(intl, "addUser.text.basicDetails")}
        </Text>
      }
      leftSection={
        <CustomInput
          required
          size={"small"}
          label={getLocalizedMessage(intl, "addUser.addUserName")}
          placeholder={getLocalizedMessage(
            intl,
            "addUser.addUserName.placeholder"
          )}
          name={addUserFormFieldNames.NAME}
          value={values[addUserFormFieldNames.NAME]}
          onChange={handleChange}
          error={
            touched[addUserFormFieldNames.NAME] &&
            errors[addUserFormFieldNames.NAME]
          }
          onBlur={handleBlur}
        />
      }
      middleSection={
        <CustomInput
          required
          size={"small"}
          label={getLocalizedMessage(intl, "addUser.addUserEmail")}
          placeholder={getLocalizedMessage(
            intl,
            "addUser.addUserEmail.placeholder"
          )}
          name={addUserFormFieldNames.EMAIL}
          error={
            touched[addUserFormFieldNames.EMAIL] &&
            errors[addUserFormFieldNames.EMAIL]
          }
          value={values[addUserFormFieldNames.EMAIL]}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      }
      rightSection={
        <CustomMobileInput
          label={getLocalizedMessage(intl, "addUser.addUserMobile")}
          required
          placeholder={getLocalizedMessage(
            intl,
            "addUser.addUserMobile.placeholder"
          )}
          options={countriesData?.map((country) => {
            return {
              label: <Text>{country?.code + "-" + country?.name}</Text>,
              value: country?.code,
            };
          })}
          showStar={false}
          name={addUserFormFieldNames.MOB_NUM}
          error={
            (touched[addUserFormFieldNames.COUNTRY_CODE] || touched[addUserFormFieldNames.MOB_NUM]) &&
            errors[addUserFormFieldNames.MOB_NUM]
              ? errors[addUserFormFieldNames.MOB_NUM]
              : (touched[addUserFormFieldNames.COUNTRY_CODE] || touched[addUserFormFieldNames.MOB_NUM]) &&
                errors[addUserFormFieldNames.COUNTRY_CODE]
          }
          value={values[addUserFormFieldNames.MOB_NUM]}
          setCountryCodeValue={setCountryCodeValue}
          onChange={(e) => mobileChangeHandler(e)}
          countryCodeValue={countryCodeValue}
          countryCodeName={addUserFormFieldNames.COUNTRY_CODE}
          valueCountryCode={values[addUserFormFieldNames.COUNTRY_CODE]}
          handleChangeCountryCode={(countryCode) => {
            countryCodeHandleChange(countryCode);
          }}
          onBlur={handleBlur}
        />
      }
    />
  );
};

export default BasicDetailsContainer;
